import { toPublicSnapshot } from "./snapshot";
import type { DisplaySnapshot, PublicDisplaySnapshot } from "./types";

export function createSampleSnapshot(now = new Date()): PublicDisplaySnapshot {
  return toPublicSnapshot(createInternalSampleSnapshot(now));
}

export function createInternalSampleSnapshot(now = new Date()): DisplaySnapshot {
  return {
    generatedAt: now.toISOString(),
    title: "智慧食堂·食安公示屏",
    licenseCards: [
      {
        id: "business-license",
        title: "营业执照",
        subtitle: "主体资质有效",
        imageUrl: "/mock/license-business.svg",
        updatedAt: "2026-05-01T08:00:00+08:00"
      },
      {
        id: "food-license",
        title: "食品经营许可证",
        subtitle: "许可信息已备案",
        imageUrl: "/mock/license-food.svg",
        updatedAt: "2026-05-01T08:00:00+08:00"
      }
    ],
    healthCertificates: {
      total: 124,
      counts: {
        normal: 64,
        expiring: 34,
        expired: 24,
        missing: 2
      },
      rows: [
        {
          id: "h-1",
          name: "张三",
          idNumber: "445224199901011234",
          idNumberMasked: "445224********1234",
          hasHealthCertificate: true,
          status: "normal",
          validUntil: "2026-10-16",
          avatarUrl: "/mock/avatar-1.svg"
        },
        {
          id: "h-2",
          name: "李四",
          idNumber: "445224199902021456",
          idNumberMasked: "445224********1456",
          hasHealthCertificate: true,
          status: "expiring",
          validUntil: "2026-08-20",
          avatarUrl: "/mock/avatar-2.svg"
        },
        {
          id: "h-3",
          name: "王五",
          idNumber: "445224199803031789",
          idNumberMasked: "445224********1789",
          hasHealthCertificate: true,
          status: "expired",
          validUntil: "2026-04-30",
          avatarUrl: "/mock/avatar-3.svg"
        },
        {
          id: "h-4",
          name: "赵六",
          idNumber: "445224199704041321",
          idNumberMasked: "445224********1321",
          hasHealthCertificate: true,
          status: "normal",
          validUntil: "2026-11-05",
          avatarUrl: "/mock/avatar-4.svg"
        },
        {
          id: "h-5",
          name: "孙七",
          idNumber: "",
          idNumberMasked: "",
          hasHealthCertificate: false,
          status: "missing",
          validUntil: "",
          avatarUrl: "/mock/avatar-5.svg"
        }
      ]
    },
    attendanceRule: {
      startTime: "09:00",
      endTime: "13:00",
      startCount: 80,
      targetCount: 386,
      frequencyMinutes: 5,
      jitter: 8,
      seed: "canteen-main-screen"
    },
    sampleRetentionRows: [
      { id: 1, dish: "红烧肉", weight: "150g", meal: "午餐", keeper: "张厨师" },
      { id: 2, dish: "青椒牛肉", weight: "150g", meal: "午餐", keeper: "李厨师" },
      { id: 3, dish: "番茄炒蛋", weight: "150g", meal: "午餐", keeper: "王厨师" },
      { id: 4, dish: "米饭", weight: "150g", meal: "午餐", keeper: "赵厨师" },
      { id: 5, dish: "紫菜汤", weight: "150g", meal: "午餐", keeper: "孙厨师" }
    ],
    reportUploads: [
      { category: "meat", title: "肉类检测报告", uploadedAt: "2026-05-12T07:40:00+08:00", assetUrl: "/mock/report-meat.svg" },
      { category: "produce", title: "蔬菜水果检测报告", uploadedAt: "2026-05-12T07:42:00+08:00", assetUrl: "/mock/report-produce.svg" },
      { category: "dryGoods", title: "干杂调料检测报告", uploadedAt: "2026-05-11T07:42:00+08:00", assetUrl: "/mock/report-dry-goods.svg" },
      { category: "staple", title: "米面油检测报告", uploadedAt: "2026-05-11T07:42:00+08:00", assetUrl: "/mock/report-staple.svg" }
    ],
    cameras: [
      { id: "cam-1", name: "后厨一", slot: 1, onvifUrl: "http://192.168.1.20/onvif/device_service", rtspUrl: "rtsp://192.168.1.20/Streaming/Channels/102", username: "admin", password: "encrypted" },
      { id: "cam-2", name: "后厨二", slot: 2, onvifUrl: "http://192.168.1.21/onvif/device_service", rtspUrl: "rtsp://192.168.1.21/Streaming/Channels/102", username: "admin", password: "encrypted" },
      { id: "cam-3", name: "仓储区", slot: 3, onvifUrl: "http://192.168.1.22/onvif/device_service", rtspUrl: "rtsp://192.168.1.22/Streaming/Channels/102", username: "admin", password: "encrypted" },
      { id: "cam-4", name: "清洗间", slot: 4, onvifUrl: "http://192.168.1.23/onvif/device_service", rtspUrl: "rtsp://192.168.1.23/Streaming/Channels/102", username: "admin", password: "encrypted" }
    ]
  };
}
